const licencia = {
  readLicenciasUsuario: 'licencias',
  readLicenciaPublicaDetallada: 'academia/{{uuid_academia}}/licencia-detallada'
}

export default licencia
